// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://dr-backend-4xmc.onrender.com/",
});

export default axiosInstance;

export const weburl = "https://dr-backend-4xmc.onrender.com/";
// export const weburl = "https://dr-backend-4xmc.onrender.com/";

export const Homeurl = "https://drarrysmediclinic.spacedeco.in/";
export const adminurl = "https://dr-backend-4xmc.onrender.com/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://test.payu.in/_payment';

// export const weburl = 'https://backend-2o7f.onrender.com/';
